import React, { FC } from "react";
import rightImgPng from "images/our-features.png";
import NcImage from "shared/NcImage/NcImage";
import Badge from "shared/Badge/Badge";

export interface SectionOurFeaturesProps {
  className?: string;
  rightImg?: string;
  type?: "type1" | "type2";
}

const SectionOurFeatures: FC<SectionOurFeaturesProps> = ({
  className = "lg:py-14",
  rightImg = rightImgPng,
  type = "type1",
}) => {
  return (
    <div
      className={`nc-SectionOurFeatures relative flex flex-col items-center ${
        type === "type1" ? "lg:flex-row" : "lg:flex-row-reverse"
      } ${className}`}
      data-nc-id="SectionOurFeatures"
    >
      <div className="flex-grow">
        <NcImage src={rightImg} />
      </div>
      <div
        className={`max-w-2xl flex-shrink-0 mt-10 lg:mt-0 lg:w-2/5 ${
          type === "type1" ? "lg:pl-16" : "lg:pr-16"
        }`}
      >
        <span className="uppercase text-sm text-gray-400 tracking-widest">
          Beneficios
        </span>
        <h2 className="font-semibold text-4xl mt-5">Preparados contigo</h2>

        <ul className="space-y-10 mt-16">
          <li className="space-y-4">
            <Badge name="Servicio" />
            <span className="block text-xl font-semibold">
              Estaremos listos cuando tú lo estés
            </span>
            <span className="block mt-5 text-neutral-500 dark:text-neutral-400">
              Consulta adónde puedes viajar en estos momentos y encuentra las mejores ofertas entre miles de vuelos, hoteles y alquileres de coches.
            </span>
          </li>
          <li className="space-y-4">
            <Badge color="green" name="Fácil" />
            <span className="block text-xl font-semibold">
              Haz planes sin preocupaciones
            </span>
            <span className="block mt-5 text-neutral-500 dark:text-neutral-400">
              Prepárate para cualquier imprevisto con las últimas actualizaciones, hoteles y coches con cancelación gratuita y seguro de viaje frente a la COVID-19.
            </span>
          </li>
          <li className="space-y-4">
            <Badge color="red" name="Seguro" />
            <span className="block text-xl font-semibold">
              Viaja sin complicaciones
            </span>
            <span className="block mt-5 text-neutral-500 dark:text-neutral-400">
              Con nosotros, siempre sabrás lo que pagas, sin sorpresas de última hora. Para que te relajes incluso antes de que empiece tu viaje.
            </span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default SectionOurFeatures;
